<template>
  <div>
    <label>Bairro</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave()"
          ref="chavePesquisa"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="onBlurChave()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-registro-selecionado w3-border"
            type="text"
            v-model="descricao_bairro_selecionado"
            @click="abrirPesquisa()"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para pesquisar"
            readonly/>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados"/>
        </div>
      </div>
    </div>

    <pesquisa-bairros
      ref="pesquisaBairros"
      @confirmar="carregar">
    </pesquisa-bairros>

  </div>
</template>

<script>
  import RBairro from '@/components/Rest/RBairro'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import PesquisaBairros from '@/components/Pesquisas/PesquisaBairros'

  export default {
    name: 'FrameBairro',

    components: {
      PesquisaBairros
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      bairroSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      cidadeSelecionada: {
        required: false,
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        descricao_bairro_selecionado: '',

        bairro_selecionado: {},
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      async inserirDadoPorChave(chave) {
        if (this.valorInt(chave) > 0) {
          this.chave_pesquisa = chave;
        }

        let bairro_id = this.valorInt(this.chave_pesquisa);

        if
          (
            (this.chave_pesquisa == '') ||
            (bairro_id <= 0)
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }

        try {

          let parametros = {
            tipo: 'COD',
            chave: bairro_id
          }

          let retorno = await RBairro.pesquisarBairros(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.carregar(JSON.parse(JSON.stringify(retorno.dados.bairros[0])));
        }
        catch (e) {
          this.limparDados();
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisa() {
        this.$refs.pesquisaBairros.abrir(this.cidadeSelecionada);
      },

      carregar(bairro) {
        this.chave_pesquisa = '';

        if ((!bairro) || (!bairro.bairro_id)) {
          this.limparDados();
          return;
        }

        this.bairro_selecionado = JSON.parse(JSON.stringify(bairro));

        this.descricao_bairro_selecionado = (
          this.bairro_selecionado.nome_bairro + ' - ' + 
          this.bairro_selecionado.nome_cidade + '/' +
          this.bairro_selecionado.estado_id
        )

        this.placeholder_codigo = Biblioteca.nPadrao(
          this.bairro_selecionado.bairro_id,
          0
        );

        this.$emit('confirmar', this.bairro_selecionado);
      },

      onBlurChave() {
        if (this.bairro_selecionado.bairro_id) {
          if (this.bairro_selecionado.bairro_id != this.valorInt(this.chave_pesquisa)) {
            this.chave_pesquisa = '';
          }
        }
        else {
          this.limparDados();
        }
      },
     
      limparDados() {
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.descricao_bairro_selecionado = '';
        this.bairro_selecionado = {};
        this.somenteLeitura = "N";
        this.cidadeSelecionada = 0;
        this.$emit('limparDados');
      },

      selecao() {
        if (this.bairro_selecionado.bairro_id) {
          return this.bairro_selecionado;
        }

        return undefined;
      },

      setCidadeSelecionada(_cidadeSelecionada) {
        this.cidadeSelecionada = _cidadeSelecionada;
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      },

      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },

    created() {
      if (this.bairroSelecionado) {
        this.carregar(this.bairroSelecionado);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    font-weight: bold;
    border-right-style: none!important;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-registro-selecionado {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameBairro.vue